<template>
  <div class="container-fluid">
    <h5 class="mb-3">
      {{  $t('modal.titleInfoDelete') }}
    </h5>

    <b-button class="float-end ms-3"
      variant="danger"
      @click="onClick"
    >
      {{ $t('modal.button.delete') }}
    </b-button>

    <b-button class="float-end"
      variant="warning"
      @click="onClose"
    >
      {{ $t('modal.button.back') }}
    </b-button>
  </div>
</template>

<script>
  import { deleteWarehouse } from '../../../api/endpoints/warehouse';
  import { listMixin } from '../../../mixins/listMixin'

  const req = {
    delete: deleteWarehouse
  }

  export default {
    name: "WarehouseDeleteModal",
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        req,
      }
    },
    mixins: [listMixin],
    methods: {
      onClick() {
        this.onDelete()
      },
      onClose() {
        this.$emit('onClose')
      }
    }
  }
</script>